export default "__VITE_ASSET__BK0cHXE9__"